import React, { useEffect } from 'react';

export const useDisableEnterKey = (isActive = true) => {
  useEffect(() => {
    if (!isActive) return;

    const handleKeyDown = (event) => {
      // if (event.target.tagName === 'TEXTAREA' && event.key === 'Enter') {
      //   return;
      // } 
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isActive]);
};

